module.exports = __webpack_public_path__ + "static/project-yrb-9d651e53013107de661ee58978ca84e2.jpg";